<template>
  <div class="view-reservations-component">
    <div class="row">
      <div class="col-lg-9 col-md-8 col-sm-12">
        <div class="box box-primary">
          <div class="box-header clearfix">
            <h1 class="box-title details">Reservation Details</h1>
            <button v-if="isReservationAccount" @click="resendEmail()" class="btn btn-default btn-sm resend"><i class="fa fa-envelope"></i> Re-Send Reservation Email</button>
          </div>
          <div class="box-body">
            <label class="label label-primary label-header" v-if="Reservation.LotRelocationUuid">One Way Trip</label>
            <label class="pull-right label label-info label-margin" v-if="Reservation.started && !Reservation.completed">Started</label>
            <label class="pull-right label label-success label-margin" v-if="Reservation.completed && !Reservation.cancelled">Completed</label>
            <label class="pull-right label label-warning label-margin" v-if="Reservation.completed && Reservation.cancelled">Completed Early</label>
            <label class="pull-right label label-danger label-margin" v-if="Reservation.cancelled && !Reservation.completed">Cancelled</label>
            <label class="pull-right label label-default label-margin" v-if="expired && !Reservation.cancelled && !Reservation.completed">Expired</label>
            <h3>Reservation # {{ Reservation.reservationId }}</h3>
            <p><strong>Driver:</strong> {{ Reservation.Account.fullName }}</p>
            <p v-if="!Reservation.isPersonal"><label class="label label-info">Business Reservation</label></p>
            <p v-if="Reservation.ReservationPromo">
              <label class="label label-info">
                <span class="fa fa-fw fa-usd"></span> <strong>Promotional Code - {{ Reservation.ReservationPromo.code }}</strong>
              </label>
            </p>
            <p v-if="Reservation.percentDiscount > 0">
              <label class="label label-primary">
                <span class="fa fa-fw fa-percent"></span> <strong>Discount - {{ Reservation.percentDiscount }}%</strong>
              </label>
            </p>
            <div class="row">
              <div class="col-sm-6">
                <p><strong>Start Date: </strong>
                  {{ Reservation.startDate | date_format Reservation.Lot.timezone }}</p>
                <p><strong>End Date: </strong>
                  {{ Reservation.endDate | date_format Reservation.Lot.timezone }}</p>
              </div>
              <div class="col-sm-6" v-if="Reservation.completed">
                <p><strong>Started Booking: </strong>
                  {{ Reservation.completedStartDate | date_format Reservation.Lot.timezone }}</p>
                <p><strong>Ended Booking: </strong>
                  {{ Reservation.completedEndDate | date_format Reservation.Lot.timezone }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <strong>Memo:</strong><br/>
                <span class="memo">{{ Reservation.memo || 'n/a' }}</span>
              </div>
            </div>
            <div class="row" v-if="Reservation.LotRelocationUuid">
              <div class="col-sm-12">
                <h5>One Way Trip Details</h5>
                <p>
                  <strong>Pickup location:</strong> {{ Reservation.Lot.address }}<br/>
                  <strong>Return location:</strong> {{ Reservation.DestinationLot.address }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <p v-if="billed && !Reservation.refunded" class="text-success">
                <strong>Billing Status:</strong>
                  <span class="fa-stack">
                    <span class="fa fa-circle fa-stack-2x"></span>
                    <span class="fa fa-dollar fa-stack-1x fa-inverse"></span>
                  </span>
                  Billed
                </p>
                <p v-if="!Reservation.completed && !Reservation.cancelled && !billed" class="text-warning">
                <strong>Billing Status:</strong>
                  <span class="fa-stack">
                    <span class="fa fa-circle fa-stack-2x"></span>
                    <span class="fa fa-clock-o fa-stack-1x fa-inverse"></span>
                  </span>
                  Waiting for reservation to finalise
                </p>
                <p v-if="Reservation.refunded" class="text-info">
                  <strong>Billing Status:</strong>
                  <span class="fa-stack">
                    <span class="fa fa-circle fa-stack-2x"></span>
                    <span class="fa fa-exchange fa-stack-1x fa-inverse"></span>
                  </span>
                  Refunded
                </p>
              </div>
            </div>
            <form action="/api/private/get-invoice" method="post" v-el:form>
              <input type="hidden" name="token" v-model="token">
              <input type="hidden" name="reservationId" v-model="Reservation.uuid">
            </form>
            <button :disabled="!billed" class="btn btn-default btn-sm" @click="getInvoice()"><i class="fa fa-download"></i> Download Tax Invoice</button>
            <div v-if="!billed">
              <div class="callout callout-info no-margin">
                <p>
                  The tax invoice will be available to download once this
                  reservation has been completed as additional charges may be
                  applied at the completion of your booking.
                </p>
              <ul class="list-margin">
                <li>Each kilometre travelled is billed at ${{ Reservation.perKmCost }}/km.</li>
                <li>{{ Reservation.includeKms }}km is only included when a booking uses the daily rate.</li>
                <li>{{ Reservation.includeKms }}km is included for each daily rate charged to your booking.</li>
                <li>Should you return the car late, every 15 min over your booking end time will incur an additional hour charged.</li>
                <li>Any tolls used within the month, will be billed to the reservation the following month.</li>
                <li>Any additional reservation charges such as the above may be captured from a Pre-Authorization at the end of the 7 day hold period.</li>
              </ul>
              <p>For more information regarding charges, please refer to the <a :href="$root.muaUrl" target="_blank">Member User Agreement</a></p></div>
            <small>* 150km are only included when a car is booked for the entire day. </small></div>
            <h4>Cost Breakdown</h4>
            <div class="well price-breakdown">
              <div class="row">
                <div class="col-xs-5"><strong>Description</strong></div>
                <div class="col-xs-2"><strong>Units</strong></div>
                <div class="col-xs-3"><strong>Cost</strong></div>
                <div class="col-xs-2"><strong>Total</strong></div>
              </div>
              <div class="row" v-if="costBreakdown.cost.days > 0">
                <div class="col-xs-5">Daily Rate</div>
                <div class="col-xs-2">{{ costBreakdown.cost.days }}</div>
                <div class="col-xs-3">
                  {{ costBreakdown.rate.dailyRate | currency_round }}/day
                </div>
                <div class="col-xs-2">
                  {{ costBreakdown.cost.dailySubTotal | currency_round }}
                </div>
              </div>
              <div class="row" v-if="costBreakdown.cost.hours > 0">
                <div class="col-xs-5">Hourly Rate</div>
                <div class="col-xs-2">{{ costBreakdown.cost.hours }}</div>
                <div class="col-xs-3">
                  {{ costBreakdown.rate.hourlyRate | currency_round }}/hr
                </div>
                <div class="col-xs-2">
                  {{ costBreakdown.cost.hourlySubTotal | currency_round }}
                </div>
              </div>
              <div class="row" v-if="costBreakdown.cost.overnightHours > 0">
                <div class="col-xs-5">Overnight Rate (5pm - 8am)</div>
                <div class="col-xs-2">{{ costBreakdown.cost.overnightHours }}</div>
                <div class="col-xs-3">
                  {{ costBreakdown.rate.overnightRate | currency_round }}
                </div>
                <div class="col-xs-2">
                  {{ costBreakdown.cost.overnightSubTotal | currency_round }}
                </div>
              </div>
              <div class="row" v-if="costBreakdown.cost.weekendSubTotal > 0">
                <div class="col-xs-5">Weekend Rate</div>
                <div class="col-xs-2">{{ costBreakdown.cost.weekendDays }}</div>
                <div class="col-xs-3">
                  {{ costBreakdown.rate.weekendRate | currency_round }}
                </div>
                <div class="col-xs-2">
                  {{ costBreakdown.cost.weekendSubTotal | currency_round }}
                </div>
              </div>
              <div class="row" v-if="Reservation.extras.length > 0">
                <div class="col-xs-5"><strong>Optional Extras</strong></div>
                <div class="col-xs-2"><strong></strong></div>
                <div class="col-xs-3"><strong></strong></div>
                <div class="col-xs-2"><strong></strong></div>
              </div>
              <template v-for="extra in Reservation.extras">
                <template v-if="extra.rateType === 'fixed'">
                  <div class="row">
                    <div class="col-xs-5">{{ extra.name }}</div>
                    <div class="col-xs-2">1</div>
                    <div class="col-xs-3">{{ extra.cost | currency_round }}</div>
                    <div class="col-xs-2">{{ extra.cost | currency_round }}</div>
                  </div>
                </template>
                <template v-if="extra.rateType === 'rate'">
                  <div class="row" v-if="costBreakdown.cost.days > 0">
                    <div class="col-xs-5">{{ extra.name }} (Daily Rate)</div>
                    <div class="col-xs-2">{{ costBreakdown.cost.days }}</div>
                    <div class="col-xs-3">{{ extra.dailyRate | currency_round }}/day</div>
                    <div class="col-xs-2">
                      {{ extra.dailyRate * costBreakdown.cost.days | currency_round }}
                    </div>
                  </div>
                  <div class="row" v-if="costBreakdown.cost.hours > 0">
                    <div class="col-xs-5">{{ extra.name }} (Hourly Rate)</div>
                    <div class="col-xs-2">
                      {{ costBreakdown.cost.hours }}
                    </div>
                    <div class="col-xs-3">{{ extra.hourlyRate | currency_round }}/hr</div>
                    <div class="col-xs-2">
                      {{ extra.hourlyRate * costBreakdown.cost.hours
                         | currency_round }}
                    </div>
                  </div>
                  <div class="row" v-if="costBreakdown.cost.overnightHours > 0">
                    <div class="col-xs-5">{{ extra.name }} (Overnight Rate)</div>
                    <div class="col-xs-2">{{ costBreakdown.cost.overnightHours }}</div>
                    <div class="col-xs-3">{{ extra.overnightRate | currency_round }}</div>
                    <div class="col-xs-2">
                      {{ extra.overnightRate * costBreakdown.cost.overnightHours |
                        currency_round }}
                    </div>
                  </div>
                  <div class="row" v-if="costBreakdown.cost.weekendDays > 0">
                    <div class="col-xs-5">{{ extra.name }} (Weekend Rate)</div>
                    <div class="col-xs-2">{{ costBreakdown.cost.weekendDays }}</div>
                    <div class="col-xs-3">{{ extra.weekendRate | currency_round }}</div>
                    <div class="col-xs-2">
                      {{ extra.weekendRate * costBreakdown.cost.weekendDays |
                        currency_round }}
                    </div>
                  </div>
                </template>
              </template>
              <div class="row" v-if="Reservation.kmFee || Reservation.lateFee">
                <div class="col-xs-5"><strong>Extras</strong></div>
                <div class="col-xs-2"><strong></strong></div>
                <div class="col-xs-3"><strong></strong></div>
                <div class="col-xs-2"><strong></strong></div>
              </div>
              <template v-if="Reservation.kmFee">
                <div class="row">
                  <div class="col-xs-5">
                    Completed KMs <br/>
                    <span class="grey">( {{ 150 * this.costBreakdown.cost.days }} km included )</span>
                  </div>
                  <div class="col-xs-2">{{ Reservation.completedKms }}</div>
                  <div class="col-xs-3">{{ Reservation.perKmCost | currency_round }}/km</div>
                  <div class="col-xs-2">{{ Reservation.kmFee | currency_round }}</div>
                </div>
              </template>
              <template v-if="Reservation.lateFee">
                <div class="row">
                  <div class="col-xs-5">Late Fee</div>
                  <div class="col-xs-2" v-if="minutesLate > 0">{{ minutesLate }} min late</div>
                  <div class="col-xs-2" v-else>0</div>
                  <div class="col-xs-3">{{ Reservation.hourlyRate | currency_round }}/15 minutes</div>
                  <div class="col-xs-2">{{ Reservation.lateFee | currency_round }}</div>
                </div>
              </template>
              <hr/>
              <div class="row" v-if="Reservation.percentDiscount">
                <div class="col-xs-5"><strong>Discount</strong></div>
                <div class="col-xs-2"></div>
                <div class="col-xs-3"></div>
                <div class="col-xs-2 credit"><strong>{{ Reservation.percentDiscount }}%</strong></div>
              </div>
              <div class="row">
                <div class="col-xs-5"><strong>Total</strong></div>
                <div class="col-xs-2"></div>
                <div class="col-xs-3"></div>
                <div class="col-xs-2" v-if="!Reservation.completed">{{ Reservation.quotedCost | currency_round}}</div>
                <div class="col-xs-2" v-else>{{ Reservation.actualCost | currency_round}}</div>
              </div>
              <div class="row" v-if="Reservation.percentDiscount">
                <div class="col-xs-5"><strong>You Saved</strong></div>
                <div class="col-xs-2"></div>
                <div class="col-xs-3"></div>
                <div class="col-xs-2 credit">
                  <strong v-if="!Reservation.completed">{{ Reservation.preDiscountCost - Reservation.quotedCost | currency_round }}</strong>
                  <strong v-else>{{ Reservation.preDiscountCost - Reservation.actualCost | currency_round }}</strong>
                </div>
              </div>
            </div>
            <h4>Booking History</h4>
            <div class="list-group-item created">
              <span class="fa fa-3x fa-pull-right fa-calendar-plus-o desc"></span>
              <p>
                <strong class="desc">Created reservation</strong><br/>
                <strong class="card-title">Start Date: </strong><br class="show-br" />{{ createdReservation.startTime | date_format Reservation.Lot.timezone }}<br/>
                <strong class="card-title">End Date: </strong><br class="show-br" />{{ createdReservation.endTime | date_format Reservation.Lot.timezone }}<br/>
                <strong class="card-title">Date Created: </strong><br class="show-br" />{{ Reservation.createdAt | date_format Reservation.Lot.timezone }}
              </p>
            </div>
            <template v-for="message in messages">
              <div class="list-group-item modify">
                <booking-modify-display :message="message" :timezone="Reservation.Lot.timezone"></booking-modify-display>
              </div>
            </template>
            <div class="list-group-item cancelled" v-if="cancelledAt">
              <span class="fa fa-3x fa-pull-right fa-calendar-times-o desc"></span>
              <p>
                <strong class="desc">Cancelled reservation</strong><br/>
                <strong class="card-title">Date Cancelled: </strong><br class="show-br" />{{ cancelledAt | date_format Reservation.Lot.timezone }}
              </p>
            </div>
            <h4>Charges</h4>
            <template v-if="Reservation.HeldCharge">
              <div class="list-group-item" v-if="Reservation.HeldCharge.CapturedReservationUuid === Reservation.uuid">
                <p>
                  <strong class="card-title">Description: </strong><br class="show-br" />Pre-Authorisation Captured for Additional Reservation Charges<br/>
                  <strong class="card-title">Amount Captured: </strong><br class="show-br" />{{ Reservation.HeldCharge.cost - Reservation.HeldCharge.refunded | currency }}<br/>
                  <strong class="card-title">Amount Refunded: </strong><br class="show-br" />{{ Reservation.HeldCharge.refunded | currency }}<br/>
                  <strong class="card-title">Date Recorded: </strong><br class="show-br" />{{ Reservation.HeldCharge.createdAt | short_date_format }}
                </p>
              </div>
            </template>
            <template v-if="Reservation.FinanceCodeUuid">
              <div class="alert alert-success">
                <span class="fa fa-check fa-2x fa-pull-right fa-fw"></span>
                <h4>Finance Code in Use:</h4>
                <p><strong>{{ Reservation.FinanceCode.code }}</strong><br/>
                {{ Reservation.FinanceCode.description }}</p>
              </div>
            </template>
            <p class="callout callout-warning" v-if="hasPendingCharges">
              This reservation has pending charges. These charges will be taken
              from your Pre-Authorization at the end of the 7 day hold period.
              You can view all pending charges by <a v-link="{ path: '/preauth/'+Reservation.HeldChargeUuid }"><strong>clicking here</strong></a>.
            </p>
            <template v-for="charge in Reservation.ReservationCharges">
              <div class="list-group-item">
                <p class="pull-right">
                  <label class="label label-info label-margin" v-if="charge.refunded">Refunded</label>
                  <label class="label label-warning label-margin" v-if="charge.pending">Pending</label>
                  <label class="label label-danger label-margin" v-if="charge.failed">Failed</label>
                </p>
                <p>
                  <strong class="card-title">Description: </strong><br class="show-br" />{{ charge.description }}<br/>
                  <strong class="card-title">Amount: </strong><br class="show-br" />{{ charge.cost | currency }}<br/>
                  <strong class="card-title">Date Recorded: </strong><br class="show-br" />{{ charge.createdAt | short_date_format }}
                </p>
              </div>
            </template>
            <template v-if="Reservation.CreditCharges.length > 0 || Reservation.AccountCredits.length > 0">
              <template v-for="credit in Reservation.CreditCharges">
                <div class="list-group-item">
                  <p class="pull-right">
                    <label class="label label-info label-margin" v-if="credit.refunded">Refunded</label>
                  </p>
                  <p>
                    <strong class="card-title">Description: </strong><br class="show-br" />{{ credit.description }}<br/>
                    <strong class="card-title">Amount: </strong><br class="show-br" />{{ credit.amount | currency_round }}<br/>
                    <strong class="card-title">Date Recorded: </strong><br class="show-br" />{{ credit.createdAt | short_date_format }}
                  </p>
                </div>
              </template>
              <template v-for="creditGained in Reservation.AccountCredits">
                <div class="list-group-item">
                  <p class="pull-right" v-if="creditGained.refunded">
                    <label class="label label-info label-margin">Refunded</label>*
                  </p>
                  <p>
                    <strong class="card-title">Description: </strong><br class="show-br" />Credit given for Modification of Reservation #{{ Reservation.reservationId }}<br/>
                    <strong class="card-title">Amount: </strong><br class="show-br" />{{ creditGained.cost | currency_round }}<br/>
                    <strong class="card-title">Date Recorded: </strong><br class="show-br" />{{ creditGained.createdAt | short_date_format }}
                  </p>
                </div>
              </template>
              <small v-if="Reservation.refunded">* Account credits given during reservation modification are taken back from your account balance in the event of a full refund.<br/></small>
            </template>
            <br/>
            <p class="alert alert-info">
              All prices are inclusive of G.S.T.<br/>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-12">
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Car Details</h1>
          </div>
          <div class="box-body">
            <car-display :car="Car"></car-display>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import CarDisplay from '../displays/CarDisplay.vue'
import StripeCharges from '../displays/StripeCharges.vue'
import BookingModifyDisplay from '../displays/BookingModifyDisplay.vue'
import Util from '../../../server/util'

export default {
  name: 'ViewReservation',
  components: {
    BookingModifyDisplay,
    CarDisplay,
    StripeCharges
  },
  data () {
    return {
      hasPendingCharges: false,
      token: '',
      isReservationAccount: false,
      cancelledAt: false,
      rate: {},
      billed: false,
      createdReservation: {},
      Car: {
        Lot: {},
        CarType: {
          AmazonImage: {}
        }
      },
      costBreakdown: {
        cost: {},
        rate: {}
      },
      promoRate: {},
      expired: false,
      Reservation: {
        Account: {},
        extras: [],
        AccountCredits: [],
        CreditCharges: [],
        FinanceCode: {},
        ReservationPromo: {}
      },
      messages: [],
      charges: []
    }
  },
  ready () {
    this.getReservation()
  },
  computed: {
    minutesLate () {
      return moment(this.Reservation.completedEndDate).diff(moment(this.Reservation.endDate), 'minutes')
    }
  },
  methods: {
    getInvoice () {
      this.token = window.sessionStorage.getItem('token')
      this.$nextTick(() => {
        this.$els.form.submit()
      })
    },
    getCost () {
      let rate = {
        rate: {
          dailyRate: this.Reservation.dailyRate,
          hourlyRate: this.Reservation.hourlyRate,
          weekendRate: this.Reservation.weekendRate,
          overnightRate: this.Reservation.overnightRate
        },
        car: {
          Lot: {
            hasOvernight: this.Reservation.hasWeekend,
            hasWeekend: this.Reservation.hasWeekend,
            timezone: this.Reservation.Lot.timezone || null
          }
        }
      }
      if (this.Reservation.ReservationPromo) {
        rate.rate = this.promoRate
      }
      let startDate = this.Reservation.startDate
      let endDate = this.Reservation.endDate
      let extras = this.Reservation.extras
      let calculateCost = Util.calculateCosts(rate, startDate, endDate, extras, 0, 0)
      this.costBreakdown.cost = calculateCost.cost
      this.costBreakdown.rate = rate.rate
      this.rate = rate
    },
    getReservation () {
      let params = this.$route.params
      let authType = this.$route.authType
      this.$http.get(`${authType}/reservation/${this.$route.params.reservationId}`, { params }).then(({ data }, status, request) => {
        this.Reservation = data.reservation
        this.Reservation.ReservationCharges.forEach(charge => {
          if (charge.pending) this.hasPendingCharges = true
        })
        this.promoRate = data.promoRate
        this.messages = data.messages
        this.cancelledAt = data.cancelledAt
        this.Car = data.reservation.Car
        this.Car.Lot = data.reservation.Lot
        this.createdReservation = data.createdReservation
        this.isReservationAccount = data.isReservationAccount
        this.getCost()
        let now = moment()
        if (now.isAfter(this.Reservation.endDate)) this.expired = true
        if ((this.Reservation.completed || this.Reservation.cancelled || this.expired) && !this.hasPendingCharges) {
          this.billed = true
        }
        if (this.Reservation.chargeId && this.Reservation.chargeId.indexOf('ch_') === 0) {
          this.Reservation.chargeId = false
        }
      })
    },
    resendEmail () {
      let rate = this.rate
      let reservation = this.Reservation
      let authType = this.$route.authType
      this.$http.post(`${authType}/reservation/resend-email`, { rate, reservation }).then(({ data }, status, request) => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// ViewReservation.vue?586727ee